import { call, put } from 'redux-saga/effects'
import { apiConfig } from '../../../../../config/api-config'
import { makeAccess } from '../../../../../config/factory-controller'
import * as action from '../actions/refresh-jwt-actions'

interface RefreshJwtPayload {
  login: string
  userId: number
  companyId: number
}

interface RefreshJwtResponse {
  success: boolean
  data?: {
    token: string
  }
  message?: string
}

const refreshJwtController = async (payload: RefreshJwtPayload): Promise<string> => {
  const { key, token } = await makeAccess()
  
  let baseURL = import.meta.env.VITE_REACT_APP_API_URL
  // Remover barra final se existir
  if (baseURL.endsWith('/')) {
    baseURL = baseURL.slice(0, -1)
  }
  
  // Obter o JWT do usuário do localStorage
  const userToken = localStorage.getItem('token')
  
  const response = await fetch(`${baseURL}/Auth/RefreshJwt`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-version': String(import.meta.env.VITE_REACT_APP_API_VERSION),
      'x-application-key': key,
      'x-application-token': token,
      ...(userToken && { 'Authorization': `Bearer ${userToken}` }),
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`HTTP ${response.status}: ${errorText}`)
  }

  const data: RefreshJwtResponse = await response.json()
  
  if (!data.success || !data.data?.token) {
    throw new Error(data.message || 'Token no recibido del servidor')
  }

  return data.data.token
}

export function* refreshJwtSaga({ payload }: any): any {
  try {
    const newToken: string = yield call(refreshJwtController, payload)
    
    // Salvar o novo token no localStorage
    localStorage.setItem('token', newToken)
    
    yield put(action.RefreshJwtSuccess({ token: newToken }))
  } catch (error: any) {
    yield put(action.RefreshJwtError(error.message || error.toString()))
  }
}
